export interface MonthBoundaries {
    start: Date;
    end: Date;
}

export const getMonthBoundaries = (
    date: Date = new Date(),
): MonthBoundaries => {
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);

    return { start: startOfMonth, end: endOfMonth };
};
